import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { onMounted, onUpdated, ref } from 'vue';
import defaultImage from "../assets/images/defaultImage.png";

declare let process: any;


export default /*@__PURE__*/_defineComponent({
  __name: 'Image',
  props: ['src'],
  setup(__props) {

const props = __props;
let imageUrl = ref(defaultImage);
let resourceUrl = process.env.VUE_APP_RESOURCE_URL || "";

const setImageUrl = () => {
  if (props.src) {
    if (props.src.startsWith('http')) {
      // If starts with http, it is web url check for existence and assign
      checkIfImageExists(props.src).then(() => {
        imageUrl.value = props.src;
      }).catch(() => {
        console.error("Image doesn't exist");
      })
    } else if (props.src.indexOf('assets/') != -1 || props.src.startsWith('/img/')) {
      // Assign directly in case of assets or if image starts with /img/ (when url start with /img/ then the img is the local asset url of the app)
      imageUrl.value = props.src;
    } else {
      // Image is from resource server, hence append to base resource url, check for existence and assign
      const newImageUrl = resourceUrl.concat(props.src)
      checkIfImageExists(imageUrl.value).then(() => {
        imageUrl.value = newImageUrl;
      }).catch(() => {
        console.error("Image doesn't exist");
      })
    }
  }
}

const checkIfImageExists = (src: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => reject(false);
    img.src = src;
  })
}

onMounted(() => {
  setImageUrl();
})

onUpdated(() => {
  setImageUrl();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", { src: _unref(imageUrl) }, null, 8, _hoisted_1))
}
}

})